<template>
  <editor
    v-model="inputVal"
    :api-key="tinymceApiKey"
    :disabled="disabled"
    :init="{
      height: 200,
      menubar: false,
      plugins: [
        'advlist autolink lists link image charmap print preview anchor',
        'searchreplace visualblocks code fullscreen',
        'insertdatetime media table paste code help wordcount'
      ],
      toolbar:
        'undo redo | formatselect | bold italic backcolor | \
        alignleft aligncenter alignright alignjustify | \
        bullist numlist outdent indent | removeformat | help'
    }"
  />
</template>

<script>
import Editor from '@tinymce/tinymce-vue'

export default {
  components: {
    Editor
  },

  props: {
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      tinymceApiKey: process.env.VUE_APP_TINYMCE_API_KEY
    }
  },

  computed: {
    inputVal: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style lang="scss">
.tox.tox-tinymce {
  border: 0px;
  &.tox-tinymce--disabled {
    .tox-toolbar__primary {
      background-color: #999999 !important;
    }
  }
  .tox-editor-header {
    .tox-toolbar__primary {
      background: #f4f4f4;
      border-radius: 3px;
    }
  }
  .tox-statusbar {
    border: 0px;
  }
  .tox-statusbar__branding,
  .tox-statusbar__wordcount {
    display: none;
  }
  .tox-tbtn svg {
    fill: #50575e;
  }
}
</style>
